const wrapper = "oaewizr52e";
const svg = "oaesuiefaf";
const publisherLogoWrapper = "oaepyuyw6k";
const publisherLogo = "oaeps1onkm";

export { publisherLogo, publisherLogoWrapper, svg, wrapper };
import "./atom.basic-footer.style.linaria.module.css";
//# sourceMappingURL=atom.basic-footer.style.js.map
